var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.$ls.get('api_token') !== null)?_c('MenuBar',{attrs:{"language":_vm.language,"languageValues":_vm.languageValues},on:{"change-language":_vm.onChangeLanguage}}):_vm._e(),_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }